import { WarningFilled } from "@ant-design/icons";
import { Modal } from "antd";
import { useDeleteAccount } from "../../api/api.delete";
import { IAccount } from "../../types/types";

export default function DeleteCardDialog({
  open,
  onCancel,
  onSuccess,
  onError,
  card,
}: {
  card?: IAccount;
  onSuccess: () => void;
  onError: () => void;
  open: boolean;
  onCancel: () => void;
}) {
  const { mutateAsync: deleteAsync, isPending } = useDeleteAccount();

  const handleDeleteAccount = () => {
    deleteAsync({ accountId: card?.id! })
      .then(() => onSuccess())
      .catch(() => onError());
  };

  return (
    <Modal
      title="Delete Account"
      closable={{ "aria-label": "Custom Close Button" }}
      open={open}
      onOk={handleDeleteAccount}
      onCancel={onCancel}
      okButtonProps={{ loading: isPending, disabled: isPending }}
    >
      <div className="flex flex-col mb-10">
        <div className="mt-4 flex items-start gap-3 rounded-xl border border-red-200 bg-red-50 px-4 py-3">
          <div className="mt-0.5">
            <WarningFilled
              className="text-orange-500"
              style={{ fontSize: 18 }}
            />
          </div>

          <div className="flex flex-col">
            <p className="font-semibold text-red-500">
              Are you sure you would like to delete this account?
            </p>

            <p className="text-sm mt-3">
              Expenses associated with this account will not be afftected,
              however reporting will not show this account anymore.
            </p>

            <p className="text-sm mt-3">
              <span className="font-semibold">Note:</span>{" "}
              <span>
                If you have experienced auto-sync failures for this account,
                please re-sync instead of deleting.
              </span>{" "}
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
}
